/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    removeInfo: {
        id: 'quoteandbind.PPRLinedirectives.templates.Remove Tiny Homes',
        defaultMessage: 'Remove Tiny Homes',
    },
    removeInfoDesc: {
        id: 'quoteandbind.PPRLinedirectives.templates.Tiny Homes',
        defaultMessage: 'Are you sure you want to remove this Tiny Homes from the list?',
    }
});